import type { CSSProperties, ReactNode } from 'react';

export function Icon({
  d,
  size = 16,
  stroke = 1.5,
  fill = 'none',
  style,
}: {
  d: ReactNode;
  size?: number;
  stroke?: number;
  fill?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      {d}
    </svg>
  );
}

export const I = {
  home: (<><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /></>),
  cal: (<><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></>),
  user: (<><circle cx="12" cy="8" r="4" /><path d="M4 21c1-4 5-6 8-6s7 2 8 6" /></>),
  users: (<><circle cx="9" cy="8" r="3.5" /><circle cx="17" cy="9" r="2.5" /><path d="M3 20c1-3 4-5 6-5s5 2 6 5" /><path d="M15 19c0-2 2-3 3-3s3 1 3 3" /></>),
  chat: (<><path d="M21 12a8 8 0 1 1-3.4-6.5L21 4l-1 4.4A7.9 7.9 0 0 1 21 12z" /></>),
  wallet: (<><rect x="3" y="6" width="18" height="13" rx="2" /><path d="M16 13h2M3 10h18" /></>),
  ticket: (<><path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V8z" /><path d="M9 6v12" strokeDasharray="2 2" /></>),
  chart: (<><path d="M4 20V8M10 20V4M16 20v-8M22 20H2" /></>),
  bell: (<><path d="M6 9a6 6 0 0 1 12 0c0 5 2 7 2 7H4s2-2 2-7z" /><path d="M10 20a2 2 0 0 0 4 0" /></>),
  search: (<><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></>),
  plus: (<><path d="M12 5v14M5 12h14" /></>),
  close: (<><path d="M6 6l12 12M18 6L6 18" /></>),
  check: (<><path d="M4 12l5 5L20 6" /></>),
  more: (<><circle cx="5" cy="12" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="19" cy="12" r="1.5" /></>),
  menu: (<><path d="M3 6h18M3 12h18M3 18h18" /></>),
  drag: (<><circle cx="9" cy="6" r="1.2" /><circle cx="9" cy="12" r="1.2" /><circle cx="9" cy="18" r="1.2" /><circle cx="15" cy="6" r="1.2" /><circle cx="15" cy="12" r="1.2" /><circle cx="15" cy="18" r="1.2" /></>),
  phone: (<><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" /></>),
  line: (<><path d="M22 11c0 4.4-4.5 8-10 8-1 0-1.9-.1-2.8-.3L4 21l1.5-4.3C3.4 15.3 2 13.3 2 11c0-4.4 4.5-8 10-8s10 3.6 10 8z" /></>),
  flame: (<><path d="M12 3s4 4 4 8a4 4 0 1 1-8 0c0-2 1-3 1-3s-1 5 3 5 3-4 0-10z" /></>),
  doc: (<><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6M9 13h6M9 17h6" /></>),
  edit: (<><path d="M4 20h4l10-10-4-4L4 16v4z" /><path d="m13 6 5 5" /></>),
  filter: (<><path d="M4 5h16l-6 8v6l-4-2v-4z" /></>),
  shield: (<><path d="M12 3l8 3v6c0 4-3.5 7.5-8 9-4.5-1.5-8-5-8-9V6z" /></>),
  settings: (<><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9c.4.6.9 1 1.5 1H21a2 2 0 0 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" /></>),
  refresh: (<><path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5" /></>),
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  pin: (<><path d="M12 21s-7-7-7-12a7 7 0 0 1 14 0c0 5-7 12-7 12z" /><circle cx="12" cy="9" r="2.5" /></>),
  layers: (<><path d="m12 3 9 5-9 5-9-5 9-5z" /><path d="m3 13 9 5 9-5M3 18l9 5 9-5" /></>),
  zap: (<><path d="M13 2 4 14h7l-2 8 9-12h-7z" /></>),
  trend: (<><path d="m3 17 6-6 4 4 8-9" /><path d="M14 6h7v7" /></>),
  alert: (<><path d="M12 3 2 21h20L12 3z" /><path d="M12 10v4M12 18h0" /></>),
  building: (<><path d="M3 21V7a2 2 0 0 1 2-2h6v16" /><path d="M11 21V11h8a2 2 0 0 1 2 2v8" /><path d="M7 9h0M7 13h0M7 17h0M15 15h0M15 19h0" /></>),
  package: (<><path d="m21 8-9-5-9 5v8l9 5 9-5z" /><path d="m3.3 8 8.7 5 8.7-5M12 13v10" /></>),
  device: (<><rect x="4" y="3" width="16" height="18" rx="2" /><path d="M10 18h4" /></>),
  room: (<><path d="M3 21V8l9-5 9 5v13" /><rect x="9" y="13" width="6" height="8" /></>),
  doctor: (<><circle cx="12" cy="8" r="3.5" /><path d="M5 21c1-4 4-6 7-6s6 2 7 6" /><path d="M14 12v3M12 12v3" /></>),
  arrow: (<><path d="M5 12h14M13 6l6 6-6 6" /></>),
  arrowLeft: (<><path d="M19 12H5M11 6l-6 6 6 6" /></>),
  arrowDown: (<><path d="M12 5v14M6 13l6 6 6-6" /></>),
  arrowUp: (<><path d="M12 19V5M6 11l6-6 6 6" /></>),
  sparkle: (<><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8" /></>),
  globe: (<><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></>),
  download: (<><path d="M12 3v14M6 11l6 6 6-6M4 21h16" /></>),
  eye: (<><path d="M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></>),
  history: (<><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5M12 7v5l3 2" /></>),
} as const;

export type IconKey = keyof typeof I;
